import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M16.841 13.333v-3.125a6.042 6.042 0 1 0-12.083 0v3.125" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M4.758 12.875a2.25 2.25 0 0 1 2.25-2.25 1.5 1.5 0 0 1 1.5 1.5v2.417a1.5 1.5 0 0 1-1.5 1.5 2.25 2.25 0 0 1-2.25-2.25v-.917Zm8.333-.75a1.5 1.5 0 0 1 1.5-1.5 2.25 2.25 0 0 1 2.25 2.25v.917a2.25 2.25 0 0 1-2.25 2.25 1.5 1.5 0 0 1-1.5-1.5v-2.417Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);